import type { RootState } from "@src/store/rootState";
import { getVariationMods } from "@src/store/slices/experienceBuilder/common/selectors/getVariationMods";

export const hasVariationMods = (state: RootState) =>
  getVariationMods(state).length > 0;
